import { Trans } from '@lingui/react/macro'
import type { ReactNode } from 'react'
import { useEffect } from 'react'
import { showNewIntercomMessage } from '@jotta/intercom'
import { useGetConfig } from '@jotta/grpc-connect-client/config'
import { cn } from '@jotta/utils/css'
import { handleUnknownError } from '@jotta/types/AppError'

type ErrorMessageProps = {
  className?: string
  error?: Error | string | null
  children?: ReactNode
  marginTop?: boolean
}

export function ErrorMessage({
  error,
  children,
  className,
  marginTop,
}: ErrorMessageProps) {
  const supportLink = useGetConfig()?.data?.brandingInfo?.supportLink
  const errorMessage = typeof error === 'string' ? error : error?.message
  const view =
    typeof error === 'string' ? error : error && handleUnknownError(error).view

  useEffect(() => {
    if (error) {
      reportError(error)
    }
  }, [error])

  return (
    (error || children || view) && (
      <div
        className={cn(
          'alert alert-danger body-sm-ln',
          { 'mt-4': marginTop },
          className,
        )}
      >
        {error && !view && (
          <>
            <h3 className="alert-title">
              <Trans>We're sorry! Something went wrong</Trans>
            </h3>
            <div />
            <div>
              <Trans>
                Please try again or reach out to our{' '}
                <a
                  target="_blank"
                  className="link"
                  rel="noreferrer"
                  href={supportLink}
                  onClick={e => showNewIntercomMessage(e, errorMessage)}
                >
                  customer support
                </a>
              </Trans>
              <div className="mt-4">{errorMessage}</div>
            </div>
            <div />
          </>
        )}
        <div>
          {children}
          {view}
        </div>
      </div>
    )
  )
}
